import { render, staticRenderFns } from "./warehousinfo.vue?vue&type=template&id=1d5bf2d8&scoped=true"
import script from "./warehousinfo.vue?vue&type=script&lang=js"
export * from "./warehousinfo.vue?vue&type=script&lang=js"
import style0 from "./warehousinfo.vue?vue&type=style&index=0&id=1d5bf2d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5bf2d8",
  null
  
)

export default component.exports